var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-3",style:(_vm.cardClass)},[_c('chart',{attrs:{"type":"radial-bar","data":_vm.newData,"labels":_vm.chartData.labels,"total":_vm.newTotal,"elevation":"0","title":_vm.title,"width":"auto","id":'radial-chart-' +
        _vm.title
          .toLowerCase()
          .split(' ')
          .slice(3, 5)
          .join('-')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }